import { render } from "./DetallesAdicionalTicketComponent.vue?vue&type=template&id=9e6d8672&scoped=true"
import script from "./DetallesAdicionalTicketComponent.vue?vue&type=script&lang=js"
export * from "./DetallesAdicionalTicketComponent.vue?vue&type=script&lang=js"

import "./DetallesAdicionalTicketComponent.vue?vue&type=style&index=0&id=9e6d8672&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e6d8672"]])

export default __exports__